/**
 *
 * parseSet
 * Recursively convert arrays to idObjects
 * Except for timeslots, used too often as array
 *
 */

import { makeIdObject } from 'utils/arrays.js';
import { SLOT_OPEN } from '../constants.js';
import parseMeeting from './parseMeeting.js';

function parseSet(set) {
  const students = set.students && makeIdObject(set.students, ['connections']);

  // make IdObject with meetings with details
  const meetings = { list: [] };
  set.meetings.forEach((meeting) => {
    const { id, studentId } = meeting;
    const parentIds = students ? meeting.parentIds.filter((p) => students[studentId].connections[p]) : meeting.parentIds;
    if (parentIds.length === 0) {
      return;
    }
    meetings[id] = parseMeeting(meeting);
    meetings.list.push(id);
  });

  const fixSlot = (slot) => slot.meetingId && !meetings[slot.meetingId] ? { ...slot, meetingId: null, status: SLOT_OPEN } : slot;

  const blocks = { list: [] };
  set.blocks.forEach((block) => {
    const { id, timeslots } = block;
    if (!timeslots || timeslots.length === 0) {
      return;
    }
    blocks[id] = {
      ...block,
      timeslots: block.timeslots.map(fixSlot),
    };
    blocks.list.push(id);
  });

  const result = {
    ...set,
    students,
    meetings,
    blocks,
  };
  return result;
}

export default parseSet;
